const rowsAndFieldsAndLabelsMX = [
  {
    street: 'Calle',
    number: 'Número exterior',
    intNumber: 'Número interior (opcional)',
  },
  {
    suburb: 'Colonia',
    zipCode: 'Código postal',
  },
  {
    addresseePhone: 'Teléfono'
  },
  {
    crossStreet: 'Entre calles',
  },
  {
    reference: 'Referencia',
  },
  {
    observations: 'Observaciones (opcional)'
  }
]

const rowsAndFieldsAndLabelsCO = [
  {
    locality: 'Localidad',
  },
  {
    street: 'Dirección',
  },
  {
    suburb: 'Barrio',
  },
  {
    addresseePhone: 'Teléfono'
  },
  {
    crossStreet: 'Indicaciones/Referencias',
  },
  {
    reference: 'Edificio/Interior/Apto',
  },
  {
    observations: 'Observaciones (opcional)'
  }
]

export {
  rowsAndFieldsAndLabelsCO,
  rowsAndFieldsAndLabelsMX
}